export default "__VITE_PUBLIC_ASSET__099f9aec__"